import { AppButtonProps } from "../../AppButton/next";

import {
  renderButton_unstable,
  useButtonStyles_unstable,
} from "@fluentui/react-button";
import * as React from "react";
import { useAppSplitButtonPrimaryButton } from "./useAppSplitButtonPrimaryButton";

export const AppSplitButtonPrimaryButton = React.memo(
  React.forwardRef<HTMLButtonElement, AppButtonProps>((props, ref) => {
    const state = useAppSplitButtonPrimaryButton(props, ref);

    useButtonStyles_unstable(state);

    return renderButton_unstable(state);
  })
);

AppSplitButtonPrimaryButton.displayName = "next/AppSplitButtonPrimaryButton";
